import {
	TableCell,
	TableRow,
	CircularProgress,
	Typography,
	TablePagination,
	Popover,
	Divider,
	ListItem,
	ListItemText,
	List
} from '@material-ui/core';
import { DateTimeFormatter } from 'helpers/DateHelpers';
import { GetUserId, GetUserKey, GetUserToken } from 'helpers/UserHelper';
import { GetFnaHistory } from 'queries/fna/queries';
import React, { Component } from 'react';
import { Query } from 'react-apollo';
import FnaHistoryContainer from './containers/FnaHistoryContainer.jsx';
import EmptyBody from 'components/Table/EmptyBody.jsx';
import { ParseUriParams } from 'helpers/UriReader';

const columnData = [
	{
		id: 'description',
		numeric: false,
		disablePadding: true,
		label: 'Description'
	},
	{
		id: 'clientFullName',
		numeric: false,
		disablePadding: true,
		label: 'Client Name'
	},
	{
		id: 'date_created_raw',
		numeric: false,
		disablePadding: true,
		label: 'Date Created'
	}
];

class FnaHistory extends Component {
	state = {
		page: 0,
		rowsPerPage: 5,
		order: 'desc',
		orderBy: 'date_created_raw',
		searchTerm: '',
		selectedFna: null,
		anchorTop: 0,
		anchorLeft: 0,
		popoverOpen: false,
		assistantActive: false
	};

	handleSearch = (event, refetch) => {
		this.setState({ searchTerm: event.target.value });
		this.handleClose();
		refetch();
	};

	handleChangePage = (page, refetch) => {
		this.setState({ page: page });
		this.handleClose();
		refetch();
	};

	handleChangeRowsPerPage = (event, refetch) => {
		this.setState({ rowsPerPage: event.target.value });
		this.handleClose();
		refetch();
	};

	handleRequestSort = (event, property, refetch) => {
		const orderBy = property;
		let order = 'desc';

		if (this.state.orderBy === property && this.state.order === 'desc') {
			order = 'asc';
		}
		this.handleClose();
		this.setState({ order, orderBy });

		refetch();
	};

	handleEdit(fna) {
		this.props.history.push({
			pathname: '/app/newfna',
			search: `clientId=${fna.client_id}&id=${fna.id}`
		});
	}

	handleView(fna) {
		this.props.history.push({
			pathname: '/app/fnaresults',
			search: `fnaId=${fna.id}`
		});
	}

	handleViewJson(fna) {
		this.props.history.push({
			pathname: '/app/fnaresultsjson',
			search: `fnaId=${fna.id}`
		});
	}

	handleNewFna = () => {
		this.props.history.push('/app/clientforfna');
	};

	handleClose = () => {
		this.setState({ popoverOpen: false, selectedFna: null });
	};

	handleOpen = (event, fna) => {
		this.setState({
			anchorTop: event.clientY,
			anchorLeft: event.clientX,
			popoverOpen: true,
			selectedFna: fna
		});
	};

	checkAssistantActive() {
		if (GetUserKey('userType') === '6') {
			if (!this.state.assistantActive) {
				this.setState({ assistantActive: true });
			}
			return true;
		}
		return false;
	}

	getBrokerId = () => {
		let brokerId = GetUserId();
		if (this.checkAssistantActive()) {
			brokerId = sessionStorage.getItem('ActiveBrokerId');
		}
		return brokerId;
	};

	getBrokerName = () => {
		return sessionStorage.getItem('ActiveBrokerName');
	};

	render() {
		const colSpan = Object.keys(columnData).length;

		const params = ParseUriParams(this.props.location.search);
		const { clientId, clientName } = params;

		return (
			<Query
				query={GetFnaHistory}
				variables={{
					brokerId: this.getBrokerId(),
					token: GetUserToken(),
					limit: this.state.rowsPerPage,
					page: this.state.page,
					orderBy: this.state.orderBy,
					direction: this.state.order,
					search: this.state.searchTerm,
					clientId: clientId
				}}
				fetchPolicy="network-only"
			>
				{({ loading, error, data, refetch }) => {
					if (loading) {
						return (
							<FnaHistoryContainer
								{...this.state}
								addClicked={this.handleNewFna}
								brokerName={this.getBrokerName()}
								handleSearch={e => this.handleSearch(e, refetch)}
								handleRequestSort={(event, property) =>
									this.handleRequestSort(event, property, refetch)
								}
								clientName={clientName}
								columnData={columnData}
								tableBody={
									<EmptyBody
										colSpan={colSpan}
										rowSpan={this.state.rowsPerPage}
										placeHolder={<CircularProgress />}
									/>
								}
							/>
						);
					}
					if (error) return `Error! ${error.message}`;

					const items = data.FnaHistory.Results;
					const count = data.FnaHistory.Count;

					return (
						<FnaHistoryContainer
							{...this.state}
							addClicked={this.handleNewFna}
							brokerName={this.getBrokerName()}
							handleSearch={e => this.handleSearch(e, refetch)}
							handleRequestSort={(event, property) =>
								this.handleRequestSort(event, property, refetch)
							}
							clientName={clientName}
							columnData={columnData}
							tableBody={
								<React.Fragment>
									{items.length < 1 && this.state.searchTerm !== '' ? (
										<EmptyBody
											colSpan={colSpan}
											rowSpan={this.state.rowsPerPage}
											placeHolder={
												<Typography variant="subheading">
													{this.state.searchTerm !== ''
														? 'No results found'
														: 'No FNAs created yet. Click on Create FNA'}
												</Typography>
											}
										/>
									) : (
										<React.Fragment>
											{items.map(fna => {
												return (
													<TableRow
														className="sqDataTable"
														key={fna.id}
														onClick={e =>
															this.state.popoverOpen === false
																? this.handleOpen(e, fna)
																: null
														}
														style={
															this.state.selectedFna &&
															this.state.selectedFna.id === fna.id
																? { backgroundColor: '#dedede' }
																: {}
														}
													>
														<TableCell>{fna.description}</TableCell>
														<TableCell>{fna.clientFullName}</TableCell>
														<TableCell>
															{DateTimeFormatter(fna.date_created)}
														</TableCell>
													</TableRow>
												);
											})}
											<Popover
												open={this.state.popoverOpen}
												anchorReference="anchorPosition"
												anchorPosition={{
													left: this.state.anchorLeft,
													top: this.state.anchorTop
												}}
												onClose={() => this.handleClose()}
											>
												<List component="nav">
													<ListItem
														button
														onClick={() =>
															this.handleView(this.state.selectedFna)
														}
													>
														<ListItemText primary="View Results" />
													</ListItem>
													<Divider />
													<ListItem
														button
														divider
														onClick={() =>
															this.handleEdit(this.state.selectedFna)
														}
													>
														<ListItemText primary="Edit Fna" />
													</ListItem>
													<ListItem
														button
														divider
														onClick={() =>
															this.handleViewJson(this.state.selectedFna)
														}
													>
														<ListItemText primary="JSON RESULTS" />
													</ListItem>
												</List>
											</Popover>
											{[...Array(this.state.rowsPerPage - items.length)].map(
												i => {
													return <TableRow key={i} colSpan={colSpan} />;
												}
											)}
										</React.Fragment>
									)}
									<TableRow>
										<TablePagination
											count={count}
											rowsPerPage={this.state.rowsPerPage}
											page={this.state.page}
											backIconButtonProps={{
												'aria-label': 'Previous Page'
											}}
											nextIconButtonProps={{
												'aria-label': 'Next Page'
											}}
											onChangePage={(event, page) =>
												this.handleChangePage(page, refetch)
											}
											onChangeRowsPerPage={event =>
												this.handleChangeRowsPerPage(event, refetch)
											}
										/>
									</TableRow>
								</React.Fragment>
							}
						/>
					);
				}}
			</Query>
		);
	}
}

export default FnaHistory;



// WEBPACK FOOTER //
// ./src/views/Fna/FnaHistory.jsx